import { render, staticRenderFns } from "./DashboardCreate.vue?vue&type=template&id=640af2bb&"
import script from "./DashboardCreate.vue?vue&type=script&lang=js&"
export * from "./DashboardCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports